import React from "react";
import { View, Text, Image } from "@react-pdf/renderer";

import { styles } from "./pdfStyles";
import { Row, NumField } from "./pdfPrimitives";

// react-pdf's <Image> cannot rasterize SVG, so the PDF uses the PNG logo that
// already ships alongside the cover page (the legacy raster path used the SVG).
import voltaLogo from "../F280FirstPage/logo-color.png";
import HVACDCLogo from "../F280FirstPage/HVACDCLogo.png";

// Grey title bar shared by every page (legacy `.titleContainer`).
export const TitleBar = ({ title, subtitle, rightPrimary, rightSecondary, titleStyle }) => (
    <View style={styles.titleContainer}>
        <View style={styles.titleSubtitleWrapper}>
            <Text style={[styles.titleH1, titleStyle]}>{title}</Text>
            {subtitle ? <Text style={styles.subtitle}>{subtitle}</Text> : null}
        </View>
        <View style={styles.rightSubContainer}>
            <Text style={styles.titleRightSpan}>
                {rightPrimary}
                {"\n"}
                {rightSecondary}
            </Text>
        </View>
    </View>
);

// "These documents issued for the use of ___" + PROJECT # row, shared by all
// three pages. Matches the CSA reference form: the name underline stops short
// of the cell edge and the continuation sentence is indented on its own line.
export const DisclaimerProjectRow = ({ t, issuedForTheUseOf, projectNo }) => (
    <Row>
        <View style={[styles.cell, styles.fullFlex, { paddingBottom: 4 }]}>
            <View style={styles.nameContainer}>
                <Text style={styles.regText}>
                    {t("f280pdf.disclaimer.1", "These documents were issued for the use of [!!]")}
                </Text>
                <View style={[styles.inputName, { marginRight: 30 }]}>
                    {/* Fixed height + single line: the row's height must not depend on
                        whether a value is present. Otherwise a filled value adds the
                        fontSize-9 line height, which on the densely-packed page 2
                        overflows the footer onto an extra page. */}
                    <Text style={styles.nameContainerValue} maxLines={1}>
                        {issuedForTheUseOf}
                    </Text>
                </View>
            </View>
            <Text style={[styles.regText, { marginLeft: 60, marginTop: 4 }]}>
                {t(
                    "f280pdf.disclaimer.2",
                    "and may not be used by any other persons without authorization. Documents for permit and/or construction are signed in red. [!!]"
                )}
            </Text>
            <NumField>1</NumField>
        </View>
        <View style={[styles.cell, styles.borderLeft, { width: 110, padding: 0 }]}>
            <View style={styles.projectNumber}>
                <Text style={styles.projectNumberSpan}>{t("f280pdf.projectNum", "PROJECT # [!!]")}</Text>
                <Text style={styles.projectNumberValue}>{projectNo}</Text>
            </View>
            <NumField>2</NumField>
        </View>
    </Row>
);

// Bottom logo strip shared by every page (legacy final `.row`).
export const Footer = ({ footnote, num = "63", noBorder = true }) => (
    <View style={[styles.footerRow, noBorder && styles.noBorderBottom]}>
        <View style={styles.footerLogoCell}>
            <Image src={voltaLogo} style={styles.footerLogo} />
            <Text style={styles.footnote}>{footnote}</Text>
            <NumField>{num}</NumField>
        </View>
        <View style={styles.footerHvacCell}>
            <Image src={HVACDCLogo} style={styles.footerHvacLogo} />
        </View>
    </View>
);
